import ServiceResponse from '@services/models/ServiceResponse';
import { partnerQCProductSearch } from '@services/urls/apiGatewayURLs';

const MESSAGE = 'gtin, productName, lat and long are required';

async function getProductNearUser({
  axios,
  gtin,
  productName,
  latitude,
  longitude,
}) {
  try {
    if (!gtin || !productName || !latitude || !longitude)
      return new ServiceResponse({ error: MESSAGE });

    const { data } = await axios.post(partnerQCProductSearch, {
      location: {
        latitude,
        longitude,
      },
      product: {
        name: productName,
      },
      filters: {
        gtin,
        priority_find: ['DMART'],
        business_types: ['GROCERIES'],
        vendors: [],
      },
    });
    return new ServiceResponse({ data });
  } catch (error) {
    return new ServiceResponse({ error });
  }
}

export default getProductNearUser;
